export default __webpack_public_path__ + "static/media/logo.8f13ad42.svg";